import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { makeGetContact } from 'reduxes/slices/contacts/selectors'

import { useGetPublicContact } from './use_get_public_contact'

export const useHandleMetadata = (
  handle: string | undefined,
  participant?: any, // for participant lists where a participant may not have a contact, pass in the participant as a param
) => {
  const getContact = useMemo(makeGetContact, [])
  // eslint-disable-next-line
  // @ts-ignore
  const contact = useSelector((state) => getContact(state, { handle }))
  const publicContact = useGetPublicContact(handle)

  const name =
    publicContact?.name ||
    contact?.account_name ||
    participant?.name_from_handle ||
    handle

  return {
    publicContact,
    contact,
    name,
  }
}
